import { authSetUnauthorized } from '@slices/auth';

import { removeAuthData } from '@storage/auth';
import { removeProjectsData } from '@storage/projects';

import { appResetStore } from '@actions/app/app-reset-store';

import { AuthLogout } from './types';

export const authLogout: AuthLogout = () => (dispatch) => {
  removeAuthData();
  removeProjectsData();

  dispatch(authSetUnauthorized());
  dispatch(appResetStore());
};
